;(function ($) {
  var initExpandable = function () {
    $('.pr-expandable').not('.pr-expandable-initialized').addClass('pr-expandable-initialized').expandable()
  }

  $(document).ready(initExpandable)
  initExpandable()
})(jQuery)
